import GDPR from '../../terms/gdpr';
import React from 'react';
import Countries from '~/components/countries_enum.ts';
import FetchPolicy from "../../../src/fetchPolicy";


const GDPRPolicy = ({markdownData}) => {
    return (
        <GDPR markdownData={markdownData} />
    )
}


export async function getServerSideProps({ query, res }) {
    let lang = query.lang
    if (lang !== 'cs') lang = 'en'

    const data = await FetchPolicy(lang, Countries.CZECHIA_SHORT, 'pay/GDPR', 'GDPR', query?.branch);
    //console.log(data)
    if (null !== data.redirectUrl) {
        console.error('FetchPolicy problem, redirected to Github, terms');
        res.redirect(302, data.redirectUrl);
    }
    return {
        props: {
            markdownData: data,
        },
    };
}

export default GDPRPolicy;
